import { render, staticRenderFns } from "./GlobalStyles.vue?vue&type=template&id=97e57dd4"
import script from "./GlobalStyles.vue?vue&type=script&lang=js"
export * from "./GlobalStyles.vue?vue&type=script&lang=js"
import style0 from "./GlobalStyles.vue?vue&type=style&index=0&id=97e57dd4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e57dd4')) {
      api.createRecord('97e57dd4', component.options)
    } else {
      api.reload('97e57dd4', component.options)
    }
    module.hot.accept("./GlobalStyles.vue?vue&type=template&id=97e57dd4", function () {
      api.rerender('97e57dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/GlobalStyles.vue"
export default component.exports